import axios from "axios";

import { getUserDetails } from "./getUserDetails";

export const checkAndRedirectByRole = async (navigate) => {
  try {
    const response = await axios.get("/api/session/", {
      withCredentials: true,
    });
    if (response.data.isAuthenticated) {
      const userDetails = await getUserDetails();
      const userId = userDetails?.id;
      const userResponse = await axios.get(`/api/users/${userId}/`, {
        withCredentials: true,
      });
      const role = userDetails?.role;
      const company = userResponse.data?.company;

      // Check if candidate is new (no applicationids or empty array)
      if (role === "candidate") {
        const isNewUser =
          !userResponse.data.applicationids ||
          userResponse.data.applicationids.length === 0;
        if (isNewUser) {
          navigate("/setprofile", { replace: true });
          return;
        }
      }

      if (role) {
        if (
          (role === "recruiter" ||
            role === "smallbiz_owner" ||
            role === "nonprofit") &&
          !company
        ) {
          navigate("/orgprofile", { replace: true });
        } else {
          // Normal navigation
          let path = "/";
          if (role === "candidate") path = "/home";
          else path = "/orghome";
          navigate(path, { replace: true });
        }
      } else {
        console.error("User role missing");
      }
    }
  } catch (error) {
    console.error("Error checking authentication status", error);
  }
};
